module.exports = __webpack_public_path__ + "static/media/pick3logo.a4d1ebe5.png";